import { render } from "./App.vue?vue&type=template&id=b13c96ce"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b13c96ce&lang=css"

import exportComponent from "D:\\CarlosRocha\\Vue\\Pokemon Game Wirh Vue\\04-pokemon-game-with-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__